import React, { useEffect, useState } from 'react'
import { PureAutocomplete } from 'elentari'

export const codigosMotivosOptions = [
  { label: 'AMARELO', value: 'AMARELO' },
  { label: 'AZUL', value: 'AZUL' },
  { label: 'BRANCO', value: 'BRANCO' },
  { label: 'CINZA', value: 'CINZA' },
  { label: 'LARANJA', value: 'LARANJA' },
  { label: 'PRETO', value: 'PRETO' },
  { label: 'ROSA', value: 'ROSA' },
  { label: 'ROXO', value: 'ROXO' },
  { label: 'VERDE', value: 'VERDE' },
  { label: 'VERMELHO', value: 'VERMELHO' }
]

const AutocompleteCodigosMotivos = ({
  input,
  meta,
  options,
  showError,
  setCodigosMotivos,
  ...props
}) => {
  const [value, setValue] = useState()
  useEffect(() => {
    const fetch = async () => {
      const option =
        options?.filter(option => input.value.includes(option.value)) || []
      setValue(option)
      setCodigosMotivos(option.map(item => item.value))
    }
    fetch()
  }, [input.value, options])

  const onChange = item => {
    setValue(item)
    input.onChange(item?.map(element => element?.value) || [])
  }
  const touched = meta.touched || showError
  return (
    <PureAutocomplete
      {...props}
      isMulti
      hideEmpty
      fullWidth
      label="Códigos Motivos"
      meta={meta}
      error={meta.error && touched}
      textFieldProps={{
        onBlur: input.onBlur,
        helperText: touched && meta.error,
        error: meta.error && touched,
        InputLabelProps: {
          shrink: input.value?.length > 0 || input.dirty
        }
      }}
      helperText={touched && meta.error}
      options={options}
      onChange={onChange}
      value={value}
    />
  )
}

export default AutocompleteCodigosMotivos
